const SINGLE_PURCHASE = "single-purchase";
const SUBSCRIPTION_PURCHASE = "subscription-purchase";
const IN_STORE_SUBSCRIPTION_PURCHASE = "instore-subscription-purchase";
export {
  IN_STORE_SUBSCRIPTION_PURCHASE,
  SINGLE_PURCHASE,
  SUBSCRIPTION_PURCHASE
};
//# sourceMappingURL=purchase-types.js.map
